"use client";

import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PlanSettings } from "@/app/types/billing/PlanSettings";
import styles from "./Pricing.module.css";

type Props = {
  features: TKey[];
  plan: PlanSettings;
};

export default function PricingFeatures(props: Props) {
  const T = useT();
  const { features, plan } = props;

  return (
    <ul className={styles.features}>
      {features.map((feature) => (
        <li className={styles.feature} key={feature}>
          <IconCheck color="var(--color-green-3)" />
          <span className={styles.featureText}>
            {T(feature)
              .replace("{{hours}}", String(plan.callHoursPerMonth))
              .replace("{{prospects}}", String(plan.prospectsPerMonth))}
          </span>
        </li>
      ))}
    </ul>
  );
}
